import { gql } from '@apollo/client';

export const DELETE_REQUIRED_DOCUMENTS = gql`
  mutation deleteRequiredDocuments($input: DeleteRequiredDocumentsInput) {
    deleteRequiredDocuments(input: $input) {
      commandId
    }
  }
`;

export const EXPORT_REQUIRED_DOCUMENTS_LIST = gql`
  mutation exportRequiredDocumentsList($filters: ExportRequiredDocumentsListInput) {
    exportRequiredDocumentsList(filters: $filters) {
      fileId
      fileName
      filePath
    }
  }
`;
